<template>
    <li>
        <div class="steps-to-objective__activity"
             @click="showReviewActivityDetails = !showReviewActivityDetails"
             v-bind:class="{ 'steps-to-objective__activity--open' : showReviewActivityDetails }">
            <div class="planned-activity__item" :class="'objective-color__border-color--'+color">
                <div class="planned-activity__date">
                    <div class="planned-activity__day">{{activity.date|moment('D')}}</div>
                    <div class="planned-activity__month">{{activity.date|moment('MMM')}}</div>
                    <div class="planned-activity__year">{{activity.date|moment('YYYY')}}</div>
                </div>
                <div class="planned-activity__title-and-category">
                    <strong>{{activity.name}}</strong>
                    <div class="your-dates__category">
                        <span class="main-category-icon" :class="iconAndColorClass"></span> {{subcategoryName}}
                    </div>
                </div>
                <div v-if="activity.strength!==null" class="planned-activity__date-strength your-dates__date-strength">
                    <translate>Strength of the day for this activity</translate>:&nbsp;<day-strength :strength="activity.strength"></day-strength>
                </div>
                <div class="planned-activity__details" v-if="showReviewActivityDetails">
                    <div class="planned-activity__description">
                        <h5 v-translate>Describe your activity:</h5>
                        {{activity.description}}
                    </div>
                    <div class="planned-activity__description">
                        <h5 v-translate>Your expected result:</h5>
                        {{activity.expected_result}}
                    </div>
                    <div class="planned-activity__description">
                        <h5 v-translate>How will you measure it:</h5>
                        {{activity.measure}}
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>
<script>
    import DayStrength from "../components/calendar/DayStrength";
    import ActivityClass from "../mixins/ActivityClass";

    export default {
        name: 'activity-review',
        props: ['activity', 'color'],
        mixins: [ActivityClass],
        data() {
            return {
                showReviewActivityDetails: false
            }
        },
        components: {DayStrength},
    }
</script>